import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from './layouts/Main';
import NotFound from "./pages/NotFound";

import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";

import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/remixicon.css";

import "./scss/style.scss";
import 'tom-select/dist/css/tom-select.css';
import Statistics from "./pages/Statistics";
import ForgotPassword from "./pages/ForgotPassword";

window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");
  if (skinMode) HTMLTag.setAttribute("data-skin", skinMode);
});

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {publicRoutes.map((route, index) => (
            <><Route path={route.path} element={route.element} key={index} />
            <Route path="/forgot-password" element={<ForgotPassword />} /></>
          ))}

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Main />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              {protectedRoutes.map((route, index) => (
                <><Route path={route.path} element={route.element} key={index} />
                <Route path="/statistics" element={<Statistics />} /></>
              ))}
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}